<div class="unauth-right-header">
  <img src="assets/images/complydome-logo.png" class="unauth-mobile-logo" alt="ComplyDome">
  <a routerLink="/login">← Back to Sign In</a>
</div>

<main class="unauth-form-area">
  <div class="unauth-card">

    <!-- ─── Forgot password: email entry (no token) ─── -->
    <ng-container *ngIf="!token">
      <h2>Reset Password</h2>
      <div class="unauth-security-badge">
        <span class="unauth-security-dot"></span>
        Secure Reset
      </div>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="requestPasswordResetLink()" novalidate>
        <div class="unauth-form-group"
          [class.has-error]="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched">
          <label for="email">Email Address</label>
          <div class="unauth-input-wrapper">
            <input
              type="email"
              id="email"
              formControlName="email"
              required
              placeholder="name@practice.com"
              aria-label="Email Address">
          </div>
          <div class="unauth-error-msg" *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched">
            <i class="fas fa-info-circle"></i>
            <span *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">Email address is required.</span>
            <span *ngIf="forgotPasswordForm.get('email')?.errors?.['pattern']">Please enter a valid email address.</span>
          </div>
        </div>

        <button
          type="submit"
          class="unauth-btn-primary"
          [disabled]="forgotPasswordForm.invalid || isLoading">
          <span class="unauth-spinner" *ngIf="isLoading"></span>
          <span *ngIf="!isLoading">Send Reset Link</span>
        </button>

        <div class="unauth-forgot">
          <a routerLink="/login">Back to Sign In</a>
        </div>
      </form>
    </ng-container>

    <!-- ─── Reset password: new + confirm password (has token) ─── -->
    <ng-container *ngIf="token">
      <h2>{{ isEntityCreationFlow ? 'Set Your Password' : 'Reset Your Password' }}</h2>
      <div class="unauth-security-badge">
        <span class="unauth-security-dot"></span>
        Secure Reset
      </div>

      <form [formGroup]="resetPasswordForm" (ngSubmit)="changePassword()" novalidate>

        <div class="unauth-form-group"
          [class.has-error]="hasError(resetPasswordForm, 'required', 'newPassword') || hasError(resetPasswordForm, 'pattern', 'newPassword')">
          <label for="newPassword">New Password</label>
          <div class="unauth-input-wrapper">
            <input
              [type]="showNewPassword ? 'text' : 'password'"
              id="newPassword"
              formControlName="newPassword"
              required
              placeholder="••••••••"
              aria-label="New Password">
            <span
              class="unauth-toggle-password"
              (click)="togglePasswordVisibility('newPassword')"
              aria-label="Toggle password visibility">
              <i [class]="showNewPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </span>
          </div>
          <div class="unauth-error-msg" *ngIf="hasError(resetPasswordForm, 'required', 'newPassword')">
            <i class="fas fa-info-circle"></i>
            <span>Password is required.</span>
          </div>
          <div class="unauth-error-msg" *ngIf="hasError(resetPasswordForm, 'pattern', 'newPassword')" (click)="showPasswordRules()">
            <i class="fas fa-info-circle"></i>
            <span>Password does not meet the requirements.</span>
          </div>
        </div>

        <div class="unauth-form-group"
          [class.has-error]="hasError(resetPasswordForm, 'required', 'confirmPassword') || hasError(resetPasswordForm, 'passwordMismatch')">
          <label for="confirmPassword">Confirm Password</label>
          <div class="unauth-input-wrapper">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword"
              required
              placeholder="••••••••"
              aria-label="Confirm Password">
            <span
              class="unauth-toggle-password"
              (click)="togglePasswordVisibility('confirmPassword')"
              aria-label="Toggle password visibility">
              <i [class]="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </span>
          </div>
          <div class="unauth-error-msg" *ngIf="hasError(resetPasswordForm, 'required', 'confirmPassword')">
            <i class="fas fa-info-circle"></i>
            <span>Password confirmation is required.</span>
          </div>
          <div class="unauth-error-msg" *ngIf="hasError(resetPasswordForm, 'passwordMismatch')">
            <i class="fas fa-info-circle"></i>
            <span>Passwords do not match.</span>
          </div>
        </div>

        <button
          type="submit"
          class="unauth-btn-primary"
          [attr.aria-label]="isEntityCreationFlow ? 'Set Password' : (email ? 'Change Password and Sign In' : 'Reset Password')"
          [disabled]="resetPasswordForm.invalid || isLoading">
          <span class="unauth-spinner" *ngIf="isLoading"></span>
          <span *ngIf="!isLoading">{{ isEntityCreationFlow ? 'Save & Sign In' : (email ? 'Change Password & Sign In' : 'Change Password') }}</span>
        </button>

        <div class="unauth-forgot" *ngIf="!isEntityCreationFlow">
          <a routerLink="/login">Back to Sign In</a>
        </div>
      </form>
    </ng-container>

  </div>
</main>
